export default class User {
  constructor(
    public id: number,
    public email: string,
    public name: string | null,
    public isSystem: boolean,
  ) { }
}